<template>
  <ui-readonly-field v-if="isFormReadonly" :label="$attrs.label" :value="value" class="ui-readonly-field--multiline" />
  <v-textarea
      v-else
      v-model="getValue"
      :error-messages="getErrorMsg"
      :error="error"
      outlined
      dense
      hide-details="auto"
      v-bind="$attrs"
      v-on="$listeners"
      class="ui-textarea"
  >
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name"/>
    </template>
  </v-textarea>
</template>

<script>
import {getErrorMsg} from '@/helpers/validation'
import FormReadonlyMixin from '@/mixins/FormReadonlyMixin'

export default {
  name: "ui-textarea",
  mixins: [FormReadonlyMixin],
  props: {
    value: null,
    errorMessages: {
      type: [String, Array, Object],
    }
  },
  computed: {
    getValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    rawErrors() {
      if (Array.isArray(this.errorMessages) || typeof this.errorMessages === 'string') {
        return this.errorMessages
      }
      return getErrorMsg(this.errorMessages)
    },
    error() {
      if (Array.isArray(this.rawErrors) && this.rawErrors.length && this.rawErrors.every(e => e === '\u200B')) return true
      if (!this.value) return this.$attrs.error
      return this.value.$error
    },
    getErrorMsg() {
      if (Array.isArray(this.rawErrors)) return this.rawErrors.filter(e => e !== '\u200B')
      if (typeof this.rawErrors === 'string') return this.rawErrors === '\u200B' ? [] : this.rawErrors
      return this.rawErrors
    }
  },
}
</script>

<style lang="scss">
.ui-textarea {
  .v-label--active {
    color: #5F6163 !important;
  }

  fieldset, .v-text-field .v-input__control {
    border-color: var(--v-black-lighten6);
  }

  .v-text-field__slot {
    .v-label {
      font-size: 12px !important;
      color: var(--v-black-lighten2);
    }

    textarea {
      font-size: 12px;
      color: var(--v-black-darken3) !important;
    }
  }
}

</style>
